import { MenuPassThrough } from "primeng/menu";

export const menuPtOptions: MenuPassThrough = {
    root: {
        class: "mt-2 p-4",
    },
};
